import { CURRENCY_SYMBOL } from "utils/constants";
import { costToFrench } from "utils/helpers/values";

const Card = ({ name, cost, currency, period, perYear, link }) => {
  const currencySymbol = CURRENCY_SYMBOL[currency] || CURRENCY_SYMBOL.EUR;

  return (
    <div className="quote-template-acoris__formula">
      <div className="quote-template-acoris__formula--name">{name}</div>
      <div className="quote-template-acoris__formula--price">
        <div className="quote-template-acoris__formula--price-monthly">
          {costToFrench(cost)}&nbsp;{currencySymbol}
          <span> {period}</span>
        </div>
        <div className="quote-template-acoris__formula--price-annual">
          {`${(+cost * 12).toLocaleString("fr-FR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })} ${currencySymbol} ${perYear}`}
        </div>
      </div>
      <div className="quote-template-acoris__formula--button">{link}</div>
    </div>
  );
};

export default Card;
